import { connect } from "react-redux";
import Proptypes from "prop-types";
import apiClient from "../../../Main/Details/api/apiClient";
import { setConnectedService } from "../../../Header/actions/creators";
import ModifyDate from "./ModifyDate";

const CloseDate = ({
  close_date_milestone: closeDate,
  uuid,
  transactionStatus,
  connectedService,
  setConnectedService: setCS,
}) => {
  const onSuccess = () => {
    if (transactionStatus !== "pending") return;
    apiClient
      .updateConnectedService(
        uuid,
        connectedService?.listingPersonId ? { listing_person_id: connectedService.listingPersonId } : {},
      )
      .then((res) => setCS(res.data));
  };

  return (
    <div className="tw-flex tw-justify-between tw-items-center tw-gap-[2px] tw-px-[12px] tw-h-[44px] tw-min-h-[44px] tw-rounded tw-bg-tinted-gray-50 tw-text-gray-75 tw-text-[14px] tw-font-semibold tw-leading-[20px]">
      Close Date
      <ModifyDate date={closeDate} onSuccess={onSuccess} />
    </div>
  );
};

CloseDate.propTypes = {
  close_date_milestone: Proptypes.shape({
    id: Proptypes.string,
    name: Proptypes.string,
    date: Proptypes.string,
  }),
  uuid: Proptypes.string,
  transactionStatus: Proptypes.string,
  connectedService: Proptypes.shape({
    listingPersonId: Proptypes.number,
  }),
  setConnectedService: Proptypes.func,
};

CloseDate.defaultProps = {
  close_date_milestone: null,
  uuid: null,
  transactionStatus: null,
  connectedService: null,
  setConnectedService: () => {},
};

export default connect(
  (state) => ({
    close_date_milestone: state.tdpDatesReducer.dates.close_date_milestone,
    uuid: state.tdpDatesReducer.uuid,
    transactionStatus: state.tdpDetailsReducer.transactionDetails?.status,
    connectedService: state.tdpDetailsReducer.connectedService,
  }),
  { setConnectedService },
)(CloseDate);
